// Composes a dial code + national number into an E.164 string, or "" when there is no national number.

const digitsOnly = (value: string): string => (value ?? '').replace(/\D/g, '');

export function toE164(dialCode: string, national: string): string {
  const cc = digitsOnly(dialCode);
  const nn = digitsOnly(national);
  if (!cc || !nn) {
    return '';
  }
  return `+${cc}${nn}`;
}
